var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { opened: _vm.data !== null },
      attrs: { id: "confirm-dialog-overlay" },
    },
    [
      _vm.data !== null
        ? _c("div", { attrs: { id: "confirm-dialog" } }, [
            _c("div", { staticClass: "confirm-text" }, [
              _c("div", { staticClass: "confirm-text-title" }, [
                _vm._v(_vm._s(_vm.data.title)),
              ]),
              _c("p", [_vm._v(_vm._s(_vm.data.text))]),
            ]),
            _c("div", { staticClass: "confirm-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-cancel",
                  on: {
                    click: function ($event) {
                      return _vm.close(false)
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  on: {
                    click: function ($event) {
                      return _vm.close(true)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.data.button))]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }